import { Disclosure } from '@headlessui/react';
import { IconAngleDown, IconAngleUp } from '@iwoca/icons';
import { FormattedMessage, useIntl } from 'react-intl';

import styles from './InterestOnlyPaymentsAccordion.module.css';
import { MoneyWithDecimals } from '../../../../ui/moneyWithDecimals';
import SummaryRow from '../../../../ui/summaryRow/SummaryRow';
import { DrawdownRepaymentSchedule } from '../../../MyOffers.types';

export const InterestOnlyPaymentsAccordion = ({
    interestOnlyPeriod,
    interestOnlySchedule
}: {
    interestOnlyPeriod: number;
    interestOnlySchedule: DrawdownRepaymentSchedule['schedule'] | null;
}) => {
    const intl = useIntl();

    return (
        <div className={styles.container}>
            <Disclosure>
                {({ open }) => (
                    <>
                        <Disclosure.Button className={styles.accordionButton}>
                            <span className={styles.wrapText}>
                                <FormattedMessage
                                    id="_.interest_only.repayment_breakdown.heading"
                                    defaultMessage="Interest-only repayments (months 1 - {interestOnlyPeriod})"
                                    values={{
                                        interestOnlyPeriod: interestOnlyPeriod
                                    }}
                                />
                            </span>
                            <span className={styles.showDetails}>
                                {open
                                    ? intl.formatMessage({
                                          id: '_.interest_only.repayment_breakdown.hide_details',
                                          defaultMessage: 'hide details'
                                      })
                                    : intl.formatMessage({
                                          id: '_.interest_only.repayment_breakdown.show_details',
                                          defaultMessage: 'show details'
                                      })}

                                {open ? (
                                    <IconAngleUp className={styles.icon} />
                                ) : (
                                    <IconAngleDown className={styles.icon} />
                                )}
                            </span>
                        </Disclosure.Button>
                        <Disclosure.Panel className={styles.accordionPanel}>
                            {interestOnlySchedule && (
                                <InterestOnlyPaymentsDetails
                                    interestOnlyPeriod={interestOnlyPeriod}
                                    interestOnlySchedule={interestOnlySchedule}
                                />
                            )}
                        </Disclosure.Panel>
                    </>
                )}
            </Disclosure>
        </div>
    );
};

export const InterestOnlyPaymentsDetails = ({
    interestOnlyPeriod,
    interestOnlySchedule
}: {
    interestOnlyPeriod: number;
    interestOnlySchedule: DrawdownRepaymentSchedule['schedule'];
}) => {
    const intl = useIntl();

    return (
        <>
            <SummaryRow>
                <span>
                    {intl.formatMessage({
                        id: '_.interest_only.repayment_breakdown.interest_only_period',
                        defaultMessage: 'Interest-only period'
                    })}
                </span>
                <span>
                    <FormattedMessage
                        id="_.interest_only.repayment_breakdown.interest_only_period_duration"
                        defaultMessage="{duration} months"
                        values={{
                            duration: interestOnlyPeriod
                        }}
                    />
                </span>
            </SummaryRow>

            {interestOnlySchedule.map((schedule, index) => (
                <SummaryRow key={schedule.date}>
                    <span>
                        <FormattedMessage
                            id="_.interest_only.repayment_breakdown.month_label"
                            defaultMessage="Month {monthNumber}"
                            values={{
                                monthNumber: index + 1
                            }}
                        />
                    </span>
                    <MoneyWithDecimals value={schedule.total} />
                </SummaryRow>
            ))}
        </>
    );
};
